
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import SingleImageUpload from '@/components/SingleImageUpload/index.vue';
import BindChargeLevel from '@/components/Recharge/level.vue';
@Component({
  components: { SingleImageUpload, BindChargeLevel },
})
export default class extends Vue {
  @Prop() model: any;
  @Prop() descModel: any;
  @Prop() imgclass!: string;
  @Prop({ default: 'pc' }) platform!: string;
  @Emit() grandTypeChange() {
    this.$emit('grandTypeChange');
  }

  stateModel = [
    {
      value: true,
      lable: '开启',
    },
    {
      value: false,
      lable: '关闭',
    },
  ];
  popupModel = [
    {
      value: true,
      lable: '默认弹出',
    },
    {
      value: false,
      lable: '默认关闭',
    },
  ];
}
